export { CITY_PATH_PARAMETER } from '@cp/common/routing/client/web';
